import { clsx } from 'clsx'
import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { openMeasurementsBanner } from 'feature/measurements/store'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { InferenceStore } from 'store/inference/InferenceStore'
import ProfileStore from 'store/profile/ProfileStore'
import css from './MeasurementsButton.module.scss'

type Props = {
  inference?: InferenceStore
  profile: ProfileStore
}

function isEdit(profile: ProfileStore) {
  if (profile.type === 'full') {
    return profile.common.userPhoto.query.measurements != null
  }
  return true
}

export const MeasurementsButton = observer(({ inference, profile }: Props) => {
  const id = inference?.inference_id
  const edit = isEdit(profile)

  const className = clsx(css.button, id && css.shake)

  const onClick = useLatestCallback(() => {
    openMeasurementsBanner(profile, inference)
  })

  if (edit) return <Button upper wide large onClick={onClick}>
    {i18n('EditMyMeasurements')}
  </Button>

  return <Space key={id} className={className} height={40} center onClick={onClick}>
    <Typo line={16} size={12} semi upper>
      {i18n('EnterYourMeasurements')}
    </Typo>
  </Space>
})
